module.exports = __webpack_public_path__ + "static/media/1.e0a05f2d.png";